import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./scss/index.scss";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import ReactSVG from "react-svg";
import { LoginForm, Offline, OfflinePlaceholder, Online, Overlay, OverlayTheme, OverlayType } from "../..";
import RegisterForm from "./RegisterForm";
import closeImg from "../../../images/x.svg";
import ForgottenPassword from "./ForgottenPassword";

var Login = /*#__PURE__*/function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Login).call(this, props));

    _this.changeActiveTab = function (active) {
      _this.setState({
        active: active
      });
    };

    _this.state = {
      active: props.active
    };
    return _this;
  }

  _createClass(Login, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var overlay = this.props.overlay;
      var show = overlay.show,
          hide = overlay.hide;
      return React.createElement(Overlay, {
        testingContext: "loginOverlay",
        context: overlay
      }, React.createElement("div", {
        className: "login"
      }, React.createElement(Online, null, React.createElement("div", {
        className: "overlay__header"
      }, React.createElement("p", {
        className: "overlay__header-text"
      }, React.createElement(FormattedMessage, {
        id: "components.OverlayManager.Login.index.282922692",
        defaultMessage: "Saleor account"
      })), React.createElement(ReactSVG, {
        path: closeImg,
        onClick: hide,
        className: "overlay__header__close-icon"
      })), React.createElement("div", {
        className: "login__tabs"
      }, React.createElement("span", {
        "data-test": "loginTab",
        onClick: function onClick() {
          return _this2.changeActiveTab("login");
        },
        className: this.state.active === "login" ? "active-tab" : ""
      }, React.createElement(FormattedMessage, {
        id: "components.OverlayManager.Login.index.3293735236",
        defaultMessage: "Sign in to account"
      })), React.createElement("span", {
        "data-test": "registerTab",
        onClick: function onClick() {
          return _this2.changeActiveTab("register");
        },
        className: this.state.active === "register" ? "active-tab" : ""
      }, React.createElement(FormattedMessage, {
        id: "components.OverlayManager.Login.index.3254057623",
        defaultMessage: "Register new account"
      }))), React.createElement("div", {
        className: "login__content"
      }, this.state.active === "login" ? React.createElement(React.Fragment, null, React.createElement(LoginForm, {
        hide: hide
      }), React.createElement(ForgottenPassword, {
        onClick: function onClick() {
          show(OverlayType.password, OverlayTheme.right);
        }
      })) : React.createElement(RegisterForm, {
        hide: hide
      }))), React.createElement(Offline, null, React.createElement(OfflinePlaceholder, null))));
    }
  }]);

  return Login;
}(React.Component);

Login.defaultProps = {
  active: "login"
};
export default Login;